import { GET_PROD_STATS } from "../actions/prodStats.actions";

const initialState = [];

export default function prodStatsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_PROD_STATS:
      return action.payload;
    default:
      return state;
  }
}
